import React, {useContext} from "react"
import {EditNoteRounded} from "@mui/icons-material";
import {NavigationContext} from "@common/context/NavigationContext";

const FloatingOpenRightNavMobile = () => {
    const { setNavVisible, setIsNavShowingRight } = useContext(NavigationContext)

    return(
        <button
            onClick={() => {
                setIsNavShowingRight(true)
                setNavVisible(true)
            }}
            title={"Open Lesson Shortcuts"}
            aria-label={"Open Lesson Shortcuts"}
            className={'ch-right-nav-mobile-button'}
        >
            <EditNoteRounded fontSize={'inherit'} />
        </button>
    );
}

export default FloatingOpenRightNavMobile;
